const groups = {
  name_en: 'Nom anglais',
  name_fr: 'Nom français',
  description_en: 'Description anglaise',
  description_fr: 'Description française',
  number_of_payments: 'Nombre de paiements',
};

export default groups;
